export const THEME_STORAGE_KEY = 'theme';

export type ThemeId = 'light' | 'dark';

export function readStoredTheme(): ThemeId {
  const raw = localStorage.getItem(THEME_STORAGE_KEY);
  return raw === 'light' ? 'light' : 'dark';
}

export function applyThemeToBody(theme: ThemeId): void {
  const isLight = theme === 'light';
  document.body.classList.toggle('theme-light', isLight);
  document.body.classList.toggle('theme-dark', !isLight);
}
